(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = (typeof window !== "undefined" ? window['React'] : typeof global !== "undefined" ? global['React'] : null);

var _react2 = _interopRequireDefault(_react);

var _d3ArcJs = require("../d3Arc.js");

var _d3ArcJs2 = _interopRequireDefault(_d3ArcJs);

var Arc = _react2["default"].createClass({

    displayName: "Arc",

    propTypes: {
        isWorld: _react2["default"].PropTypes.bool,
        countries: _react2["default"].PropTypes.arrayOf(_react2["default"].PropTypes.shape({
            name: _react2["default"].PropTypes.string.isRequired,
            population: _react2["default"].PropTypes.object.isRequired
        })).isRequired,

        selectedArea: _react2["default"].PropTypes.string,
        shouldTransition: _react2["default"].PropTypes.bool
    },

    getDefaultProps: function getDefaultProps() {
        return {
            shouldTransition: false
        };
    },

    // when the window resizes, resize the svg
    onResize: function onResize() {
        // remove the svg and reupdate to fill the space
        _d3ArcJs2["default"].removeSvg(this.getDOMNode());
        this.componentDidUpdate();
    },

    componentDidMount: function componentDidMount() {

        window.addEventListener("resize", this.onResize);

        // call this after the page has loaded so the container is the correct size.
        // d3Arc.js measures it's container when it updates
        this.boundComponentDidUpdate = this.componentDidUpdate.bind(this);
        window.addEventListener("load", this.boundComponentDidUpdate);
    },

    componentWillUnmount: function componentWillUnmount() {
        window.removeEventListener("resize", this.onResize);
        window.removeEventListener("load", this.boundComponentDidUpdate);
    },

    componentDidUpdate: function componentDidUpdate() {

        _d3ArcJs2["default"].update({
            el: this.getDOMNode(),
            countries: this.props.countries,
            selectedArea: this.props.selectedArea,
            shouldTransition: this.props.shouldTransition,
            isWorld: this.props.isWorld
        });
    },

    render: function render() {

        return _react2["default"].createElement("div", { className: "arc" });
    }

});

exports["default"] = Arc;
module.exports = exports["default"];

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../d3Arc.js":16}],2:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = (typeof window !== "undefined" ? window['React'] : typeof global !== "undefined" ? global['React'] : null);

var _react2 = _interopRequireDefault(_react);

var _Select2Jsx = require("./Select2.jsx");

var _Select2Jsx2 = _interopRequireDefault(_Select2Jsx);

var _dashboardDispatcherJs = require("../dashboard-dispatcher.js");

var _dashboardDispatcherJs2 = _interopRequireDefault(_dashboardDispatcherJs);

var AreaSelector = _react2["default"].createClass({

    displayName: "AreaSelector",

    propTypes: {
        areas: _react2["default"].PropTypes.object.isRequired,
        selectedArea: _react2["default"].PropTypes.string
    },

    getInitialState: function getInitialState() {
        return {
            chosenSupported: true
        };
    },

    handleChosenNotSupported: function handleChosenNotSupported() {
        this.setState({
            chosenSupported: false
        });
    },

    handleAreaChange: function handleAreaChange(selectedArea) {
        _dashboardDispatcherJs2["default"].setState({
            selectedArea: selectedArea
        });
    },

    getOptions: function getOptions() {

        // create a flat array full of the regions and countries. 
        // Initally sorted: region, [all region countries], region2, [all region2 countries], ...
        var areas = this.props.areas.children

        // get a flat array of all regions and their children
        .reduce(function (allAreas, region) {
            return allAreas.concat({
                name: region.name,
                type: "region"
            }).concat(region.children.map(function (country) {
                return {
                    name: country.name,
                    type: "country"
                };
            }));
        }, []);

        // if chosen isn't supported, sort them by name with regions sorted in
        if (!this.state.chosenSupported) {
            areas.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
        }

        // create <option> elements
        return areas.map(function (area) {
            return _react2["default"].createElement(
                "option",
                { value: area.name, className: area.type, key: area.name },
                area.name
            );
        });
    },

    render: function render() {

        var classes = "area-selector " + (!this.state.chosenSupported ? " area-selector--raw" : "");

        return _react2["default"].createElement(
            "div",
            { className: classes },
            _react2["default"].createElement(
                _Select2Jsx2["default"],
                {
                    onSelectChange: this.handleAreaChange,
                    value: this.props.selectedArea,
                    onNotSupported: this.handleChosenNotSupported,
                    width: "300px"
                },
                _react2["default"].createElement(
                    "option",
                    { value: this.props.areas.name, className: "world", key: "world" },
                    this.props.areas.name
                ),
                this.getOptions()
            )
        );
    }
});

exports["default"] = AreaSelector;
module.exports = exports["default"];

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../dashboard-dispatcher.js":18,"./Select2.jsx":13}],3:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = (typeof window !== "undefined" ? window['React'] : typeof global !== "undefined" ? global['React'] : null);

var _react2 = _interopRequireDefault(_react);

var _jquery = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var _jquery2 = _interopRequireDefault(_jquery);

var _ArcJsx = require("./Arc.jsx");

var _ArcJsx2 = _interopRequireDefault(_ArcJsx);

var _RegionSelectorJsx = require("./RegionSelector.jsx");

var _RegionSelectorJsx2 = _interopRequireDefault(_RegionSelectorJsx);

var _YearSelectorJsx = require("./YearSelector.jsx");

var _YearSelectorJsx2 = _interopRequireDefault(_YearSelectorJsx);

var _YearPopulationJsx = require("./YearPopulation.jsx");

var _YearPopulationJsx2 = _interopRequireDefault(_YearPopulationJsx);

var _AreaSelectorJsx = require("./AreaSelector.jsx");

var _AreaSelectorJsx2 = _interopRequireDefault(_AreaSelectorJsx);

var _GenderFocusGenderFocusJsx = require("./GenderFocus/GenderFocus.jsx");

var _GenderFocusGenderFocusJsx2 = _interopRequireDefault(_GenderFocusGenderFocusJsx);

var _MiniPanelsJsx = require("./MiniPanels.jsx");

var _MiniPanelsJsx2 = _interopRequireDefault(_MiniPanelsJsx);

var Dashboard = _react2["default"].createClass({

    displayName: "Dashboard",

    getInitialState: function getInitialState() {
        return {
            shouldTransition: false,
            size: "full" // or "mini"
        };
    },

    propTypes: {
        appState: _react2["default"].PropTypes.shape({
            countries: _react2["default"].PropTypes.array.isRequired,
            region: _react2["default"].PropTypes.string.isRequired,
            year: _react2["default"].PropTypes.number.isRequired,
            selectedArea: _react2["default"].PropTypes.string.isRequired,
            selectedAreaData: _react2["default"].PropTypes.object.isRequired,
            genderFocusData: _react2["default"].PropTypes.object.isRequired,
            rawData: _react2["default"].PropTypes.object.isRequired,
            isWorld: _react2["default"].PropTypes.bool.isRequired
        }).isRequired // the current state
    },

    componentWillReceiveProps: function componentWillReceiveProps(newProps) {

        // only transition the viz if the year has changed.
        this.setState({
            shouldTransition: this.props.appState.year !== newProps.appState.year
        });
    },

    onResize: function onResize() {

        if ((0, _jquery2["default"])(window).width() <= 690) {

            if (this.state.size !== "mini") {
                this.setState({ size: "mini" });
            }
        } else {
            if (this.state.size !== "full") {
                this.setState({ size: "full" });
            }
        }
    },

    componentDidMount: function componentDidMount() {
        window.addEventListener("resize", this.onResize);
        this.onResize(); // do this check initially
    },

    componentWillUnmount: function componentWillUnmount() {
        window.removeEventListener("resize", this.onResize);
    },

    getFullDashboard: function getFullDashboard() {
        var _props$appState = this.props.appState;
        var countries = _props$appState.countries;
        var region = _props$appState.region;
        var isWorld = _props$appState.isWorld;
        var year = _props$appState.year;
        var selectedArea = _props$appState.selectedArea;
        var rawData = _props$appState.rawData;
        var selectedAreaData = _props$appState.selectedAreaData;
        var genderFocusData = _props$appState.genderFocusData;

        return _react2["default"].createElement(
            "div",
            { className: "dashboard--full" },
            _react2["default"].createElement(
                "div",
                { className: "dashboard-header" },
                _react2["default"].createElement(
                    "div",
                    { className: "dashboard-header__content" },
                    _react2["default"].createElement(
                        "h1",
                        { className: "dashboard-header__title styled-title" },
                        _react2["default"].createElement(
                            "span",
                            null,
                            "dashboard"
                        )
                    ),
                    _react2["default"].createElement(
                        "div",
                        { className: "dashboard-header__instructions instructions" },
                        "CLICK on the arc or use the search box to explore the data"
                    )
                ),
                _react2["default"].createElement(
                    "div",
                    { className: "dashboard-header__area-selector" },
                    _react2["default"].createElement(_AreaSelectorJsx2["default"], { selectedArea: selectedArea, areas: rawData })
                )
            ),
            _react2["default"].createElement(_RegionSelectorJsx2["default"], { region: region, regions: rawData }),
            _react2["default"].createElement(
                "div",
                { className: "population-viz" },
                _react2["default"].createElement(_YearPopulationJsx2["default"], {
                    year: 2015,
                    population: selectedAreaData.population["2015"],
                    ranking: selectedAreaData.ranking["2015"],
                    selected: year == 2015 }),
                _react2["default"].createElement(_ArcJsx2["default"], {
                    isWorld: isWorld,
                    countries: countries,
                    shouldTransition: this.state.shouldTransition,
                    selectedArea: selectedArea }),
                _react2["default"].createElement(_YearSelectorJsx2["default"], { year: year }),
                _react2["default"].createElement(_YearPopulationJsx2["default"], {
                    year: 2050,
                    population: selectedAreaData.population["2050"],
                    ranking: selectedAreaData.ranking["2050"],
                    selected: year == 2050 })
            ),
            _react2["default"].createElement(_GenderFocusGenderFocusJsx2["default"], { data: genderFocusData })
        );
    },

    getMiniDashboard: function getMiniDashboard() {
        return _react2["default"].createElement(
            "div",
            { className: "dashboard--mini" },
            _react2["default"].createElement(
                "div",
                { className: "dashboard-header" },
                _react2["default"].createElement(
                    "h2",
                    { className: "dashboard-header__title styled-title" },
                    _react2["default"].createElement(
                        "span",
                        null,
                        "dashboard"
                    )
                ),
                _react2["default"].createElement(
                    "div",
                    { className: "dashboard-header__instructions" },
                    "Select country, region, or world"
                )
            ),
            _react2["default"].createElement(_AreaSelectorJsx2["default"], { selectedArea: this.props.appState.selectedArea, areas: this.props.appState.rawData }),
            _react2["default"].createElement(_MiniPanelsJsx2["default"], {
                population: this.props.appState.selectedAreaData.population,
                ranking: this.props.appState.selectedAreaData.ranking,
                genderFocusData: this.props.appState.genderFocusData })
        );
    },

    render: function render() {

        if (this.state.size == "full") {
            return this.getFullDashboard();
        } else if (this.state.size == "mini") {
            return this.getMiniDashboard();
        }
    }

});

exports["default"] = Dashboard;
module.exports = exports["default"];

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./Arc.jsx":1,"./AreaSelector.jsx":2,"./GenderFocus/GenderFocus.jsx":5,"./MiniPanels.jsx":11,"./RegionSelector.jsx":12,"./YearPopulation.jsx":14,"./YearSelector.jsx":15}],4:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = (typeof window !== "undefined" ? window['React'] : typeof global !== "undefined" ? global['React'] : null);

var _react2 = _interopRequireDefault(_react);

var _ThermometerChartJsx = require("./ThermometerChart.jsx");

var _ThermometerChartJsx2 = _interopRequireDefault(_ThermometerChartJsx);

var _NoDataJsx = require("./NoData.jsx");

var _NoDataJsx2 = _interopRequireDefault(_NoDataJsx);

var DoublePanel = _react2["default"].createClass({

    displayName: "DoublePanel",

    propTypes: {
        title: _react2["default"].PropTypes.string,
        key: _react2["default"].PropTypes.string,
        panels: _react2["default"].PropTypes.arrayOf(_react2["default"].PropTypes.shape({
            subTitle: _react2["default"].PropTypes.string,
            range: _react2["default"].PropTypes.shape({ min: _react2["default"].PropTypes.number, max: _react2["default"].PropTypes.number }),
            data: _react2["default"].PropTypes.array,
            info: _react2["default"].PropTypes.string,
            hasSignificantData: _react2["default"].PropTypes.bool
        }))
    },

    renderThermometerChart: function renderThermometerChart(panel) {

        return _react2["default"].createElement(_ThermometerChartJsx2["default"], {
            data: panel.data,
            range: panel.range,
            units: panel.units,
            hasSignificantData: panel.hasSignificantData
        });
    },

    render: function render() {

        return _react2["default"].createElement(
            "div",
            { className: "gender-focus-panel gender-focus-panel--double" },
            _react2["default"].createElement(
                "div",
                { className: "gender-focus-panel__title" },
                this.props.title
            ),
            _react2["default"].createElement(
                "div",
                { className: "gender-focus-panel__content" },
                _react2["default"].createElement(
                    "div",
                    { className: "gender-focus-panel__sub-panels" },
                    _react2["default"].createElement(
                        "div",
                        { className: "gender-focus-panel__sub-panel" },
                        _react2["default"].createElement(
                            "div",
                            { className: "gender-focus-panel__sub-title" },
                            this.props.panels[0].subTitle
                        ),
                        _react2["default"].createElement(
                            "div",
                            { className: "gender-focus-panel__chart" + (!this.props.panels[0].hasSignificantData ? " gender-focus-panel__chart--no-data" : "") },
                            _react2["default"].createElement(_NoDataJsx2["default"], null),
                            this.renderThermometerChart(this.props.panels[0])
                        )
                    ),
                    _react2["default"].createElement(
                        "div",
                        { className: "gender-focus-panel__sub-panel" },
                        _react2["default"].createElement(
                            "div",
                            { className: "gender-focus-panel__sub-title" },
                            this.props.panels[1].subTitle
                        ),
                        _react2["default"].createElement(
                            "div",
                            { className: "gender-focus-panel__chart" + (!this.props.panels[1].hasSignificantData ? " gender-focus-panel__chart--no-data" : "") },
                            _react2["default"].createElement(_NoDataJsx2["default"], null),
                            this.renderThermometerChart(this.props.panels[1])
                        )
                    )
                )
            )
        );
    }
});

exports["default"] = DoublePanel;
module.exports = exports["default"];
/* include modifier class if there is no data for the selectedArea */

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./NoData.jsx":8,"./ThermometerChart.jsx":10}],5:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = (typeof window !== "undefined" ? window['React'] : typeof global !== "undefined" ? global['React'] : null);

var _react2 = _interopRequireDefault(_react);

var _SinglePanelJsx = require("./SinglePanel.jsx");

var _SinglePanelJsx2 = _interopRequireDefault(_SinglePanelJsx);

var _DoublePanelJsx = require("./DoublePanel.jsx");

var _DoublePanelJsx2 = _interopRequireDefault(_DoublePanelJsx);

var _MaleFemalePanelJsx = require("./MaleFemalePanel.jsx");

var _MaleFemalePanelJsx2 = _interopRequireDefault(_MaleFemalePanelJsx);

var _InfoOverlayJsx = require("./InfoOverlay.jsx");

var _InfoOverlayJsx2 = _interopRequireDefault(_InfoOverlayJsx);

var GenderFocus = _react2["default"].createClass({

    displayName: "GenderFocus",

    propTypes: {
        data: _react2["default"].PropTypes.shape({
            panels: _react2["default"].PropTypes.arrayOf(_react2["default"].PropTypes.shape({
                title: _react2["default"].PropTypes.string,
                key: _react2["default"].PropTypes.string,
                panelType: _react2["default"].PropTypes.oneOf(["single", "double", "male-female"]).isRequired
            })).isRequired,
            areas: _react2["default"].PropTypes.shape({
                world: _react2["default"].PropTypes.object.isRequired,
                region: _react2["default"].PropTypes.object.isRequired,
                country: _react2["default"].PropTypes.object.isRequired
            }).isRequired
        }).isRequired
    },

    getInitialState: function getInitialState() {
        return {
            showInfo: false
        };
    },

    toggleInfo: function toggleInfo() {

        this.setState({
            showInfo: !this.state.showInfo
        });
    },

    render: function render() {
        var _props$data = this.props.data;
        var panels = _props$data.panels;
        var areas = _props$data.areas;

        var showInfo = this.state.showInfo ? " gender-focus--show-info" : "";

        return _react2["default"].createElement(
            "div",
            { className: "gender-focus" + showInfo },
            _react2["default"].createElement(
                "div",
                { className: "gender-focus__title" },
                "2015 women’s empowerment indicators"
            ),
            _react2["default"].createElement(_InfoOverlayJsx2["default"], { showInfo: this.state.showInfo, onInfoClick: this.toggleInfo }),
            _react2["default"].createElement(
                "div",
                { className: "legend" },
                _react2["default"].createElement(
                    "div",
                    { className: "legend__item" + (areas.country.name === undefined ? " legend__item--disabled" : "") },
                    _react2["default"].createElement(
                        "svg",
                        { className: "legend__icon", width: "14", height: "14" },
                        _react2["default"].createElement("circle", { cx: "7", cy: "7", r: "7", opacity: "0.8", fill: "#F2AC00" })
                    ),
                    areas.country.name || "Country"
                ),
                _react2["default"].createElement(
                    "div",
                    { className: "legend__item" + (areas.region.name === undefined ? " legend__item--disabled" : "") },
                    _react2["default"].createElement(
                        "svg",
                        { className: "legend__icon", width: "35", height: "14" },
                        _react2["default"].createElement("path", { d: "M5,7 L30,7", style: { stroke: "#7F6EA5", strokeWidth: 2, strokeLinecap: "round" } })
                    ),
                    areas.region.name || "Region"
                ),
                _react2["default"].createElement(
                    "div",
                    { className: "legend__item" },
                    _react2["default"].createElement(
                        "svg",
                        { className: "legend__icon", width: "25", height: "14" },
                        _react2["default"].createElement("path", { d: "M5,7 L20,7", style: { stroke: "#82C09A", strokeWidth: 6, strokeLinecap: "round" } })
                    ),
                    areas.world.name || "World"
                )
            ),
            _react2["default"].createElement(
                "div",
                { className: "gender-focus-panels" },
                panels.map(function (p) {

                    switch (p.panelType) {
                        case "single":
                            return _react2["default"].createElement(_SinglePanelJsx2["default"], {
                                title: p.title,
                                subTitle: p.subTitle,
                                key: p.key,
                                data: p.data,
                                range: p.range,
                                info: p.info,
                                units: p.units,
                                hasSignificantData: p.hasSignificantData
                            });

                        case "double":
                            return _react2["default"].createElement(_DoublePanelJsx2["default"], {
                                title: p.title,
                                key: p.key,
                                panels: p.panels
                            });

                        case "male-female":
                            return _react2["default"].createElement(_MaleFemalePanelJsx2["default"], {
                                title: p.title,
                                subTitle: p.subTitle,
                                key: p.key,
                                data: p.data,
                                range: p.range,
                                info: p.info,
                                units: p.units,
                                hasSignificantData: p.hasSignificantData
                            });

                        default:
                            return _react2["default"].createElement("div", { className: "gender-focus-panel", key: p.title });

                    }
                })
            )
        );
    }
});

exports["default"] = GenderFocus;
module.exports = exports["default"];

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./DoublePanel.jsx":4,"./InfoOverlay.jsx":6,"./MaleFemalePanel.jsx":7,"./SinglePanel.jsx":9}],6:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = (typeof window !== "undefined" ? window['React'] : typeof global !== "undefined" ? global['React'] : null);

var _react2 = _interopRequireDefault(_react);

var InfoOverlay = _react2["default"].createClass({

    displayName: "InfoOverlay",

    propTypes: {
        showInfo: _react2["default"].PropTypes.bool.isRequired,
        onInfoClick: _react2["default"].PropTypes.func.isRequired
    },

    render: function render() {

        var svg = _react2["default"].createElement(
            "svg",
            { version: "1.1", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 35 35", "enable-background": "new 0 0 35 35" },
            _react2["default"].createElement("circle", { fill: "#3E4E50", cx: "17.5", cy: "17.5", r: "14.2" }),
            _react2["default"].createElement("circle", { fill: "none", stroke: "#47494C", "stroke-miterlimit": "10", cx: "17.5", cy: "17.5", r: "17" }),
            this.props.showInfo ? _react2["default"].createElement("path", { id: "toggle-info-x", fill: "#C8D66C", d: "M20.2,23.5l-2.7-4.1l-2.8,4.1h-3.5l4.3-6.2l-4-5.8H15l2.5,3.7l2.5-3.7h3.5l-4,5.8 l4.3,6.2H20.2z" }) : _react2["default"].createElement("path", { id: "toggle-info-i", fill: "#C8D66C", d: "M14.4,23.4h1.7v-7.3h-1.8V14H19v9.4h1.7v2.2h-6.2V23.4z M16.1,9.4H19V12h-2.9V9.4z" })
        );

        return _react2["default"].createElement(
            "div",
            { className: "gender-focus__info" },
            _react2["default"].createElement(
                "div",
                { className: "gender-focus__info-content info-overlay" },
                _react2["default"].createElement(
                    "div",
                    { className: "info-overlay__col" },
                    _react2["default"].createElement(
                        "div",
                        { className: "info-overlay__section" },
                        _react2["default"].createElement(
                            "div",
                            { className: "info-overlay__title" },
                            "Fertility"
                        ),
                        _react2["default"].createElement(
                            "strong",
                            null,
                            "Total Fertility Rate"
                        ),
                        _react2["default"].createElement(
                            "p",
                            null,
                            "The average number of children a woman would have assuming that current age-specific birth rates remain constant throughout her childbearing years (usually considered to be ages 15 to 49)."
                        ),
                        _react2["default"].createElement(
                            "strong",
                            null,
                            "% Use of Modern Contraception"
                        ),
                        _react2["default"].createElement(
                            "p",
                            null,
                            "The percent of currently married or “in union” women of reproductive age who currently use a “modern” contraception method, such as the pill, IUD, condom, or sterilization. "
                        )
                    )
                ),
                _react2["default"].createElement(
                    "div",
                    { className: "info-overlay__col" },
                    _react2["default"].createElement(
                        "div",
                        { className: "info-overlay__section" },
                        _react2["default"].createElement(
                            "div",
                            { className: "info-overlay__title" },
                            "Education"
                        ),
                        _react2["default"].createElement(
                            "strong",
                            null,
                            "% Enrolled in Secondary School"
                        ),
                        _react2["default"].createElement(
                            "p",
                            null,
                            "The number of students enrolled in secondary education divided by the secondary-school-age population (the Gross Enrollment Ratio). The ratio can be over 100 when there are students enrolled who are older or younger than the age expected for secondary school students."
                        )
                    ),
                    _react2["default"].createElement(
                        "div",
                        { className: "info-overlay__section" },
                        _react2["default"].createElement(
                            "div",
                            { className: "info-overlay__title" },
                            "Employment"
                        ),
                        _react2["default"].createElement(
                            "strong",
                            null,
                            "% Nonagricultural Wage Earners Who Are Women "
                        ),
                        _react2["default"].createElement(
                            "p",
                            null,
                            "The percent of workers in wage employment in the nonagricultural sector who are women."
                        )
                    )
                ),
                _react2["default"].createElement(
                    "div",
                    { className: "info-overlay__col" },
                    _react2["default"].createElement(
                        "div",
                        { className: "info-overlay__section" },
                        _react2["default"].createElement(
                            "div",
                            { className: "info-overlay__title" },
                            "Government"
                        ),
                        _react2["default"].createElement(
                            "strong",
                            null,
                            "% Parliament Members Who Are Women"
                        ),
                        _react2["default"].createElement(
                            "p",
                            null,
                            "The percent of seats in a country’s single chamber, combined higher and lower chambers of the national parliament, or other national legislature held by women. "
                        )
                    ),
                    _react2["default"].createElement(
                        "div",
                        { className: "info-overlay__section" },
                        _react2["default"].createElement(
                            "div",
                            { className: "info-overlay__title" },
                            "Health"
                        ),
                        _react2["default"].createElement(
                            "strong",
                            null,
                            "Life Expectancy at Birth (Years)"
                        ),
                        _react2["default"].createElement(
                            "p",
                            null,
                            "The average number of years a newborn infant can expect to live under current mortality rates."
                        )
                    )
                )
            ),
            _react2["default"].createElement(
                "div",
                { className: "gender-focus__info-toggle", onClick: this.props.onInfoClick },
                svg
            )
        );
    }
});

exports["default"] = InfoOverlay;
module.exports = exports["default"];

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],7:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = (typeof window !== "undefined" ? window['React'] : typeof global !== "undefined" ? global['React'] : null);

var _react2 = _interopRequireDefault(_react);

var _ThermometerChartJsx = require("./ThermometerChart.jsx");

var _ThermometerChartJsx2 = _interopRequireDefault(_ThermometerChartJsx);

var _NoDataJsx = require("./NoData.jsx");

var _NoDataJsx2 = _interopRequireDefault(_NoDataJsx);

var MaleFemalePanel = _react2["default"].createClass({

    displayName: "MaleFemalePanel",

    propTypes: {
        title: _react2["default"].PropTypes.string,
        subTitle: _react2["default"].PropTypes.string,
        range: _react2["default"].PropTypes.shape({ min: _react2["default"].PropTypes.number, max: _react2["default"].PropTypes.number }),
        data: _react2["default"].PropTypes.shape({
            male: _react2["default"].PropTypes.array.isRequired,
            female: _react2["default"].PropTypes.array.isRequired
        }),
        info: _react2["default"].PropTypes.string,
        hasSignificantData: _react2["default"].PropTypes.bool,
        units: _react2["default"].PropTypes.oneOf(["%"])
    },

    getInitialState: function getInitialState() {
        return {
            hover: false
        };
    },

    renderThermometerCharts: function renderThermometerCharts() {

        return _react2["default"].createElement(
            "div",
            { className: "male-female-charts" },
            _react2["default"].createElement(_ThermometerChartJsx2["default"], {
                title: "male",
                data: this.props.data.male,
                range: this.props.range,
                dataLabel: "left",
                axisLabel: "male",
                units: this.props.units,
                hover: this.state.hover
            }),
            _react2["default"].createElement(_ThermometerChartJsx2["default"], {
                title: "female",
                data: this.props.data.female,
                range: this.props.range,
                dataLabel: "right",
                axisLabel: "female",
                units: this.props.units,
                hover: this.state.hover
            })
        );
    },

    toggleHover: function toggleHover(event) {

        // if this was a touch event, toggle the hover state
        if (event.type === "touchstart") {
            event.preventDefault(); // prevent the mouse events from being fired
            this.setState({ hover: !this.state.hover });
        } else {
            // true for mouseenter, false for mouseleave
            this.setState({ hover: event.type === "mouseenter" });
        }
    },

    render: function render() {

        return _react2["default"].createElement(
            "div",
            { className: "gender-focus-panel" },
            _react2["default"].createElement(
                "div",
                { className: "gender-focus-panel__title" },
                this.props.title
            ),
            _react2["default"].createElement(
                "div",
                { className: "gender-focus-panel__content" },
                _react2["default"].createElement(
                    "div",
                    { className: "gender-focus-panel__sub-title" },
                    this.props.subTitle
                ),
                _react2["default"].createElement(
                    "div",
                    { className: "gender-focus-panel__chart" + (!this.props.hasSignificantData ? " gender-focus-panel__chart--no-data" : ""),
                        onMouseEnter: this.toggleHover,
                        onMouseLeave: this.toggleHover,
                        onTouchStart: this.toggleHover
                    },
                    _react2["default"].createElement(_NoDataJsx2["default"], null),
                    this.renderThermometerCharts()
                )
            )
        );
    }
});

exports["default"] = MaleFemalePanel;
module.exports = exports["default"];
/* include modifier class if there is no data for the selectedArea */

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./NoData.jsx":8,"./ThermometerChart.jsx":10}],8:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = (typeof window !== "undefined" ? window['React'] : typeof global !== "undefined" ? global['React'] : null);

var _react2 = _interopRequireDefault(_react);

var NoData = _react2["default"].createClass({

    displayName: "NoData",

    render: function render() {
        return _react2["default"].createElement(
            "div",
            { className: "gender-focus-panel__no-data" },
            _react2["default"].createElement(
                "span",
                null,
                "NO DATA"
            )
        );
    }
});

exports["default"] = NoData;
module.exports = exports["default"];

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],9:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = (typeof window !== "undefined" ? window['React'] : typeof global !== "undefined" ? global['React'] : null);

var _react2 = _interopRequireDefault(_react);

var _ThermometerChartJsx = require("./ThermometerChart.jsx");

var _ThermometerChartJsx2 = _interopRequireDefault(_ThermometerChartJsx);

var _NoDataJsx = require("./NoData.jsx");

var _NoDataJsx2 = _interopRequireDefault(_NoDataJsx);

var SinglePanel = _react2["default"].createClass({

    displayName: "SinglePanel",

    propTypes: {
        title: _react2["default"].PropTypes.string,
        subTitle: _react2["default"].PropTypes.string,
        range: _react2["default"].PropTypes.shape({ min: _react2["default"].PropTypes.number, max: _react2["default"].PropTypes.number }),
        data: _react2["default"].PropTypes.array,
        info: _react2["default"].PropTypes.string,
        hasSignificantData: _react2["default"].PropTypes.bool,
        units: _react2["default"].PropTypes.oneOf(["%"])
    },

    renderThermometerChart: function renderThermometerChart() {

        return _react2["default"].createElement(_ThermometerChartJsx2["default"], {
            data: this.props.data,
            range: this.props.range,
            units: this.props.units
        });
    },

    render: function render() {

        return _react2["default"].createElement(
            "div",
            { className: "gender-focus-panel" },
            _react2["default"].createElement(
                "div",
                { className: "gender-focus-panel__title" },
                this.props.title
            ),
            _react2["default"].createElement(
                "div",
                { className: "gender-focus-panel__content" },
                _react2["default"].createElement(
                    "div",
                    { className: "gender-focus-panel__sub-title" },
                    this.props.subTitle
                ),
                _react2["default"].createElement(
                    "div",
                    { className: "gender-focus-panel__chart" + (!this.props.hasSignificantData ? " gender-focus-panel__chart--no-data" : "") },
                    _react2["default"].createElement(_NoDataJsx2["default"], null),
                    this.renderThermometerChart()
                )
            )
        );
    }
});

exports["default"] = SinglePanel;
module.exports = exports["default"];
/* include modifier class if there is no data for the selectedArea */

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./NoData.jsx":8,"./ThermometerChart.jsx":10}],10:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = (typeof window !== "undefined" ? window['React'] : typeof global !== "undefined" ? global['React'] : null);

var _react2 = _interopRequireDefault(_react);

var _d3ThermometerJs = require("../../d3Thermometer.js");

var _d3ThermometerJs2 = _interopRequireDefault(_d3ThermometerJs);

var ThermometerChart = _react2["default"].createClass({

    displayName: "ThermometerChart",

    propTypes: {
        data: _react2["default"].PropTypes.arrayOf(_react2["default"].PropTypes.shape({
            type: _react2["default"].PropTypes.oneOf(["world", "region", "country"]),
            value: _react2["default"].PropTypes.number
        })).isRequired,
        title: _react2["default"].PropTypes.string,
        range: _react2["default"].PropTypes.shape({ min: _react2["default"].PropTypes.number, max: _react2["default"].PropTypes.number }),
        dataLabel: _react2["default"].PropTypes.oneOf(["left", "right"]),
        units: _react2["default"].PropTypes.oneOf(["%"]),
        axisLabel: _react2["default"].PropTypes.oneOf(["normal", "none", "male", "female"]),
        hasSignificantData: _react2["default"].PropTypes.bool,
        hover: _react2["default"].PropTypes.bool
    },

    getInitialState: function getInitialState() {
        return {
            hover: this.props.hover
        };
    },

    componentDidMount: function componentDidMount() {

        _d3ThermometerJs2["default"].create(this.getD3Params());
    },

    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
        // update the hover state when new props come in
        this.setState({
            hover: newProps.hover
        });
    },

    componentDidUpdate: function componentDidUpdate() {

        _d3ThermometerJs2["default"].update(this.getD3Params());
    },

    toggleHover: function toggleHover(event) {

        // don'tupdate if we've been given this.props.hover.  the props value trumps state
        if (typeof this.props.hover !== "undefined") {
            return;
        }

        // if this was a touch event, toggle the hover state
        if (event.type === "touchstart") {
            event.preventDefault(); // prevent the mouse events from being fired
            this.setState({ hover: !this.state.hover });
        } else {
            // true for mouseenter, false for mouseleave
            this.setState({ hover: event.type === "mouseenter" });
        }
    },

    getD3Params: function getD3Params() {
        return {
            el: _react2["default"].findDOMNode(this.refs.svg),
            data: this.props.data,
            range: this.props.range,
            dataLabel: this.props.dataLabel,
            axisLabel: this.props.axisLabel,
            units: this.props.units,
            hasSignificantData: this.props.hasSignificantData,
            hover: this.state.hover
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "div",
            { className: "thermometer-chart" },
            _react2["default"].createElement(
                "div",
                { className: "thermometer-chart__title" },
                this.props.title
            ),
            _react2["default"].createElement("div", { className: "thermometer-chart__svg",
                ref: "svg",
                onMouseEnter: this.toggleHover,
                onMouseLeave: this.toggleHover,
                onTouchStart: this.toggleHover })
        );
    }
});

exports["default"] = ThermometerChart;
module.exports = exports["default"];

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../../d3Thermometer.js":17}],11:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = (typeof window !== "undefined" ? window['React'] : typeof global !== "undefined" ? global['React'] : null);

var _react2 = _interopRequireDefault(_react);

var MiniPanels = _react2["default"].createClass({

    displayName: "MiniPanels",

    propTypes: {

        population: _react2["default"].PropTypes.shape({
            2015: _react2["default"].PropTypes.number,
            2050: _react2["default"].PropTypes.number
        }).isRequired,
        ranking: _react2["default"].PropTypes.shape({
            2015: _react2["default"].PropTypes.shape({
                world: _react2["default"].PropTypes.number,
                region: _react2["default"].PropTypes.number,
                country: _react2["default"].PropTypes.number
            }),
            2050: _react2["default"].PropTypes.shape({
                world: _react2["default"].PropTypes.number,
                region: _react2["default"].PropTypes.number,
                country: _react2["default"].PropTypes.number
            })
        }).isRequired,
        genderFocusData: _react2["default"].PropTypes.object.isRequired
    },

    formatPopulation: function formatPopulation(population) {

        if (population / 1000000000 >= 1) {
            return {
                number: (population / 1000000000).toFixed(1),
                magnitude: "Billion"
            };
        } else if (population / 1000000 >= 1) {
            return {
                number: (population / 1000000).toFixed(1),
                magnitude: "Million"
            };
        } else if (population / 1000 >= 1) {
            return {
                number: (population / 1000).toFixed(1),
                magnitude: "Thousand"
            };
        }

        throw error("oh noes!");
    },

    renderPopulationPanel: function renderPopulationPanel() {

        var pop2015 = this.formatPopulation(this.props.population["2015"]);
        var pop2050 = this.formatPopulation(this.props.population["2050"]);

        var worldRank2015 = this.props.ranking["2015"] ? this.props.ranking["2015"].world : "-";
        var worldRank2050 = this.props.ranking["2050"] ? this.props.ranking["2050"].world : "-";

        return _react2["default"].createElement(
            "div",
            { className: "mini-panel mini-panel--population" },
            _react2["default"].createElement(
                "div",
                { className: "mini-panel__title" },
                "Population"
            ),
            _react2["default"].createElement(
                "div",
                { className: "mini-panel__two" },
                _react2["default"].createElement(
                    "div",
                    { className: "mini-panel__two-item" },
                    _react2["default"].createElement(
                        "div",
                        { className: "mini-panel__year" },
                        "2015"
                    ),
                    _react2["default"].createElement(
                        "div",
                        { className: "mini-panel__value" },
                        pop2015.number,
                        _react2["default"].createElement(
                            "span",
                            { className: "mini-panel__magnitude" },
                            pop2015.magnitude
                        )
                    )
                ),
                _react2["default"].createElement(
                    "div",
                    { className: "mini-panel__two-item" },
                    _react2["default"].createElement(
                        "div",
                        { className: "mini-panel__year" },
                        "2050"
                    ),
                    _react2["default"].createElement(
                        "div",
                        { className: "mini-panel__value" },
                        pop2050.number,
                        _react2["default"].createElement(
                            "span",
                            { className: "mini-panel__magnitude" },
                            pop2050.magnitude
                        )
                    )
                )
            ),
            _react2["default"].createElement(
                "div",
                { className: "mini-panel__title" },
                "World Ranking"
            ),
            _react2["default"].createElement(
                "div",
                { className: "mini-panel__two" },
                _react2["default"].createElement(
                    "div",
                    { className: "mini-panel__two-item" },
                    _react2["default"].createElement(
                        "div",
                        { className: "mini-panel__year" },
                        "2015"
                    ),
                    _react2["default"].createElement(
                        "div",
                        { className: "mini-panel__value" },
                        worldRank2015
                    )
                ),
                _react2["default"].createElement(
                    "div",
                    { className: "mini-panel__two-item" },
                    _react2["default"].createElement(
                        "div",
                        { className: "mini-panel__year" },
                        "2050"
                    ),
                    _react2["default"].createElement(
                        "div",
                        { className: "mini-panel__value" },
                        worldRank2050
                    )
                )
            )
        );
    },

    renderGenderFocusPanels: function renderGenderFocusPanels() {

        // only show the data for country, or region, or world (in that order)
        var significantAreaType = (function (areas) {
            if (Object.keys(areas.country).length) {
                return "country";
            }
            if (Object.keys(areas.region).length) {
                return "region";
            }
            if (Object.keys(areas.world).length) {
                return "world";
            }
        })(this.props.genderFocusData.areas);

        // for each panel, render each panel type ["single", "double", "male-female"]
        return this.props.genderFocusData.panels.map(function (panel) {

            var panelContent = null;

            switch (panel.panelType) {
                case "single":

                    // grab the data for the significant area type
                    var panelData = panel.data.find(function (p) {
                        return p.type === significantAreaType;
                    });

                    panelContent = _react2["default"].createElement(
                        "div",
                        { className: "mini-panel__content mini-panel--single" },
                        _react2["default"].createElement(
                            "div",
                            { className: "mini-panel__label" },
                            panel.subTitle
                        ),
                        _react2["default"].createElement(
                            "div",
                            { className: "mini-panel__value" },
                            panelData ? panelData.value : "-",
                            panelData && panel.units ? panel.units : ""
                        )
                    );
                    break;

                case "double":

                    panelContent = _react2["default"].createElement(
                        "div",
                        { className: "mini-panel__content mini-panel--double" },
                        panel.panels.map(function (subPanel) {

                            var subPanelData = subPanel.data.find(function (p) {
                                return p.type === significantAreaType;
                            });

                            return _react2["default"].createElement(
                                "div",
                                { className: "mini-panel__double-panel-item", key: subPanel.key },
                                _react2["default"].createElement(
                                    "div",
                                    { className: "mini-panel__label" },
                                    subPanel.subTitle
                                ),
                                _react2["default"].createElement(
                                    "div",
                                    { className: "mini-panel__value" },
                                    subPanelData ? subPanelData.value : "-",
                                    subPanelData && subPanel.units ? subPanel.units : ""
                                )
                            );
                        })
                    );
                    break;

                case "male-female":

                    var maleData = panel.data.male.find(function (p) {
                        return p.type === significantAreaType;
                    });
                    var femaleData = panel.data.female.find(function (p) {
                        return p.type === significantAreaType;
                    });

                    panelContent = _react2["default"].createElement(
                        "div",
                        { className: "mini-panel__content mini-panel--male-female" },
                        _react2["default"].createElement(
                            "div",
                            { className: "mini-panel__label" },
                            panel.subTitle
                        ),
                        _react2["default"].createElement(
                            "div",
                            { className: "mini-panel__two" },
                            _react2["default"].createElement(
                                "div",
                                { className: "mini-panel__two-item" },
                                _react2["default"].createElement(
                                    "div",
                                    { className: "mini-panel__value" },
                                    femaleData ? femaleData.value : "-",
                                    femaleData && panel.units ? panel.units : "",
                                    _react2["default"].createElement(
                                        "div",
                                        { className: "mini-panel__gender" },
                                        "female"
                                    )
                                )
                            ),
                            _react2["default"].createElement(
                                "div",
                                { className: "mini-panel__two-item" },
                                _react2["default"].createElement(
                                    "div",
                                    { className: "mini-panel__value" },
                                    maleData ? maleData.value : "-",
                                    maleData && panel.units ? panel.units : "",
                                    _react2["default"].createElement(
                                        "div",
                                        { className: "mini-panel__gender" },
                                        "male"
                                    )
                                )
                            )
                        )
                    );
                    break;
            }

            return _react2["default"].createElement(
                "div",
                { className: "mini-panel mini-panel--" + panel.key, key: panel.key },
                _react2["default"].createElement(
                    "div",
                    { className: "mini-panel__title" },
                    panel.title
                ),
                panelContent
            );
        });
    },

    render: function render() {

        return _react2["default"].createElement(
            "div",
            { className: "mini-panels" },
            this.renderPopulationPanel(),
            this.renderGenderFocusPanels()
        );
    }
});

exports["default"] = MiniPanels;
module.exports = exports["default"];

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],12:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = (typeof window !== "undefined" ? window['React'] : typeof global !== "undefined" ? global['React'] : null);

var _react2 = _interopRequireDefault(_react);

var _dashboardDispatcherJs = require("../dashboard-dispatcher.js");

var _dashboardDispatcherJs2 = _interopRequireDefault(_dashboardDispatcherJs);

var RegionSelector = _react2["default"].createClass({

    displayName: "RegionSelector",

    propTypes: {
        region: _react2["default"].PropTypes.string.isRequired, // id of the selected tab
        regions: _react2["default"].PropTypes.shape({
            name: _react2["default"].PropTypes.string,
            children: _react2["default"].PropTypes.arrayOf(_react2["default"].PropTypes.shape({
                name: _react2["default"].PropTypes.string
            }))
        }).isRequired // rawData from dispatcher state
    },

    handleClick: function handleClick(region) {

        _dashboardDispatcherJs2["default"].setState({
            selectedArea: region
        });
    },

    render: function render() {
        var _this = this;

        var regions = [];

        regions.push(this.props.regions.name); // World

        this.props.regions.children.forEach(function (region) {
            regions.push(region.name);
        });

        return _react2["default"].createElement(
            "div",
            { className: "region-selector" },
            _react2["default"].createElement(
                "div",
                { className: "region-selector__content" },
                _react2["default"].createElement(
                    "div",
                    { className: "region-selector__label" },
                    "Select View"
                ),
                regions.map(function (region) {
                    var selected = _this.props.region === region ? " region-selector__tab--selected" : "";
                    var lac = region.match(/caribbean/i) !== null ? " region-selector__tab--lac" : ""; // special treatment for LAC
                    return _react2["default"].createElement(
                        "div",
                        {
                            className: "region-selector__tab" + selected + lac,
                            key: region,
                            onClick: _this.handleClick.bind(_this, region)
                        },
                        region
                    );
                })
            )
        );
    }

});

exports["default"] = RegionSelector;
module.exports = exports["default"];

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../dashboard-dispatcher.js":18}],13:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = (typeof window !== "undefined" ? window['React'] : typeof global !== "undefined" ? global['React'] : null);

var _react2 = _interopRequireDefault(_react);

var _jquery = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var _jquery2 = _interopRequireDefault(_jquery);

var Select2 = _react2["default"].createClass({

    displayName: "Select2",

    propTypes: {
        onSelectChange: _react2["default"].PropTypes.func,
        value: _react2["default"].PropTypes.string,
        width: _react2["default"].PropTypes.oneOfType([_react2["default"].PropTypes.number, _react2["default"].PropTypes.string])
    },

    getDefaultProps: function getDefaultProps() {
        return {
            width: "resolve"
        };
    },

    componentDidMount: function componentDidMount() {

        this.getSelectElement().select2({
            width: this.props.width,
            templateResult: function templateResult(option) {

                // pass classes from <option> to <span> inside of .select2-results__option
                var className = typeof option.element !== "undefined" ? option.element.className : "";
                var text = option.text;

                // add highlight class to search text
                var searchText = (0, _jquery2["default"])(".select2-search__field").val();
                text = text.replace(new RegExp("(" + searchText + ")", "gi"), '<span class="highlight">$1</span>');

                return (0, _jquery2["default"])("<span class=\"" + className + "\">" + text + "</span>");
            }
        });

        // if select2 isn't supported, call callback (not sure if this ever happens)
        if (typeof this.getSelectElement().data().select2 === "undefined") {
            if (typeof this.props.onNotSupported === "function") {
                this.props.onNotSupported();
            }
        }

        // make sure we update when select2 updates the <select>
        this.getSelectElement().change(this.handleChange);
    },

    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        // prevent infinate loop, only update if the value has changed
        return this.props.value !== nextProps.value;
    },

    componentDidUpdate: function componentDidUpdate() {
        // update select2 whenever the data changes
        this.getSelectElement().trigger("change");
    },

    componentWillUnmount: function componentWillUnmount() {
        // remove select2 from the DOM
        this.getSelectElement().select2("destroy");
    },

    getSelectElement: function getSelectElement() {
        // the <select> element
        return (0, _jquery2["default"])(this.refs.select.getDOMNode());
    },

    handleChange: function handleChange(e) {

        // call onSelectChange from parent
        if (typeof this.props.onSelectChange === "function") {
            var value = (0, _jquery2["default"])(e.target).val();
            this.props.onSelectChange(value);
        }
    },

    render: function render() {

        return _react2["default"].createElement(
            "select",
            _extends({ ref: "select" }, this.props),
            this.props.children
        );
    }
});

exports["default"] = Select2;
module.exports = exports["default"];

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],14:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = (typeof window !== "undefined" ? window['React'] : typeof global !== "undefined" ? global['React'] : null);

var _react2 = _interopRequireDefault(_react);

var _dashboardDispatcherJs = require("../dashboard-dispatcher.js");

var _dashboardDispatcherJs2 = _interopRequireDefault(_dashboardDispatcherJs);

var YearPopulation = _react2["default"].createClass({

    displayName: "YearPopulation",

    propTypes: {
        year: _react2["default"].PropTypes.number.isRequired,
        selected: _react2["default"].PropTypes.bool,
        population: _react2["default"].PropTypes.number,
        ranking: _react2["default"].PropTypes.shape({
            world: _react2["default"].PropTypes.number,
            region: _react2["default"].PropTypes.number
        })
    },

    getDefaultProps: function getDefaultProps() {
        return {
            ranking: {}
        };
    },

    formatPopulation: function formatPopulation(population) {

        if (population / 1000000000 >= 1) {
            return (population / 1000000000).toFixed(1) + " Billion";
        } else if (population / 1000000 >= 1) {
            return (population / 1000000).toFixed(1) + " Million";
        }

        // add commas if needed
        return population.toString().replace(/(\d)(?=(\d{3})+$)/g, "$1,");
    },

    handleClick: function handleClick(year) {

        _dashboardDispatcherJs2["default"].setState({
            year: year
        });
    },

    render: function render() {

        var selected = this.props.selected ? "year-population--selected" : "";

        return _react2["default"].createElement(
            "div",
            { className: "year-population " + selected, onClick: this.handleClick.bind(this, this.props.year) },
            _react2["default"].createElement(
                "div",
                { className: "year-population__year" },
                this.props.year
            ),
            _react2["default"].createElement(
                "div",
                { className: "year-population__h1" },
                "Population"
            ),
            _react2["default"].createElement(
                "div",
                { className: "year-population__value" },
                this.formatPopulation(this.props.population) || _react2["default"].createElement(
                    "span",
                    null,
                    "—"
                )
            ),
            _react2["default"].createElement(
                "div",
                { className: "year-population__h2" },
                "World Rank"
            ),
            _react2["default"].createElement(
                "div",
                { className: "year-population__value" },
                this.props.ranking.world || _react2["default"].createElement(
                    "span",
                    null,
                    "—"
                )
            ),
            _react2["default"].createElement(
                "div",
                { className: "year-population__h2" },
                "Region Rank"
            ),
            _react2["default"].createElement(
                "div",
                { className: "year-population__value" },
                this.props.ranking.region || _react2["default"].createElement(
                    "span",
                    null,
                    "—"
                )
            )
        );
    }
});

exports["default"] = YearPopulation;
module.exports = exports["default"];

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../dashboard-dispatcher.js":18}],15:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = (typeof window !== "undefined" ? window['React'] : typeof global !== "undefined" ? global['React'] : null);

var _react2 = _interopRequireDefault(_react);

var _dashboardDispatcherJs = require("../dashboard-dispatcher.js");

var _dashboardDispatcherJs2 = _interopRequireDefault(_dashboardDispatcherJs);

var YearSelector = _react2["default"].createClass({

    displayName: "YearSelector",

    propTypes: {
        year: _react2["default"].PropTypes.number.isRequired // selected year
    },

    handleClick: function handleClick(year) {

        _dashboardDispatcherJs2["default"].setState({
            year: year
        });
    },

    render: function render() {
        var _this = this;

        var years = [2015, 2050];

        return _react2["default"].createElement(
            "div",
            { className: "year-selector" },
            _react2["default"].createElement(
                "div",
                { className: "year-selector__label" },
                "Population Rank"
            ),
            _react2["default"].createElement(
                "div",
                { className: "year-selector__tabs" },
                years.map(function (year) {
                    var selected = _this.props.year === year ? "year-selector__tab--selected" : "";

                    return _react2["default"].createElement(
                        "div",
                        {
                            className: "year-selector__tab " + selected,
                            key: year,
                            onClick: _this.handleClick.bind(_this, year)
                        },
                        year
                    );
                })
            )
        );
    }

});

exports["default"] = YearSelector;
module.exports = exports["default"];

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../dashboard-dispatcher.js":18}],16:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _d3 = (typeof window !== "undefined" ? window['d3'] : typeof global !== "undefined" ? global['d3'] : null);

var _d32 = _interopRequireDefault(_d3);

var _jquery = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var _jquery2 = _interopRequireDefault(_jquery);

var _dashboardDispatcherJs = require("./dashboard-dispatcher.js");

var _dashboardDispatcherJs2 = _interopRequireDefault(_dashboardDispatcherJs);

// private
var createSvg = function createSvg(_ref) {
    var el = _ref.el;
    var countries = _ref.countries;

    // create and append the svg
    _d32["default"].select(el).append("svg").attr("style", "overflow: visible").attr("class", "arc-svg").append("g").attr("class", "arc-svg-g"); // center the pie

    // now update with the data
    d3Arc.update(arguments[0]);
};

var d3Arc = {

    removeSvg: function removeSvg(el) {
        var svg = _d32["default"].select(el).select(".arc-svg");
        svg.remove();
    },

    // el: element to attach the chart to
    // countries: an array of country data
    // selectedArea: the name of the selectedArea ("World", a region, or a country)
    // shouldTransition:  true/false (we don't want to transition when changing regions)
    // isWorld: if the arc is showing the whole world, as opposed to a region
    update: function update(_ref2) {
        var el = _ref2.el;
        var countries = _ref2.countries;
        var selectedArea = _ref2.selectedArea;
        var _ref2$shouldTransition = _ref2.shouldTransition;
        var shouldTransition = _ref2$shouldTransition === undefined ? false : _ref2$shouldTransition;
        var isWorld = _ref2.isWorld;

        if (!countries.length) {
            console.log("POOF");return;
        }

        var svg = _d32["default"].select(el).select(".arc-svg");

        // if the svg isn't there yet, create it first
        if (!svg.node()) {
            return createSvg(arguments[0]);
        }

        // update the size
        var width = (0, _jquery2["default"])(el).width();
        var height = width / 2;
        var radius = height;
        var thickness = height / 3;
        var outsideLabelRadius = radius + 20;
        var insideLabelRadius = radius - thickness - 20;

        svg.attr("width", width).attr("height", height);

        var svgG = _d32["default"].select(el).select(".arc-svg-g");

        svgG.attr("transform", "translate(" + width / 2 + ", " + (radius + (height - radius) / 2) + ")");

        var pie = _d32["default"].layout.pie().sort(null) // make sure it preserves the sort
        .value(function (d, i) {
            return 1;
        }) // make all the slices equal width
        // .padAngle(Math.PI/2/720) // space between slices -- we're using stroke on the .slice now
        .startAngle(-Math.PI / 2).endAngle(Math.PI / 2);

        // map the values to pie objects with keys: endAngle, padAngle, startAngle, value
        var dataPie = pie(countries); // pi objects
        // const dataValues = dataPie.map(d => d.value); // array of numbers

        // const min = Math.min(...dataValues);
        // const max = Math.max(...dataValues);
        var count = countries.length;

        var transitionTime = shouldTransition ? 500 : 0;

        var colors = _d32["default"].scale.linear().range(["#295252", "#97C8C8"]);

        // function to generate an arc slice
        var arc = _d32["default"].svg.arc().innerRadius(radius - thickness).outerRadius(radius);

        // make the arc larger when hovered
        var arcHover = _d32["default"].svg.arc().innerRadius(radius - thickness).outerRadius(radius + 10);

        // create a "slice" group to hold the arc and the text
        var slice = svgG.selectAll(".slice").data(dataPie, function (d) {
            return d.data.name;
        });

        /**
         * Enter, when data points are added 
         */
        var newSlice = slice.enter().append("g").attr("class", "slice").style({
            "stroke": "white",
            "stroke-width": "1px"
        });

        // add all sub elements to the <g class="slice" />
        // HACK! the text needs to be a <g> in order for getBBox to return the box after transforms (rotate, radius) are applied
        // http://www.w3.org/TR/SVG/types.html#__svg__SVGLocatable__getBBox  "all contained graphics"
        newSlice.append("g").attr("class", "outside-label").append("text");
        newSlice.append("text").attr("class", "inside-label");
        newSlice.append("path").attr("class", "arc-path");

        /**
         * Exit, when data points are removed 
         */
        slice.exit().remove();

        /**
         * Update, when data points are changed 
         */

        // add is-selected class so we can identify the selected slice
        slice.classed("is-selected", function (d) {
            return d.data.name === selectedArea;
        });

        var selectedSlice = slice.filter(function (d) {
            return d.data.name === selectedArea;
        });

        // update arc path
        var arcPath = slice.select(".arc-path");

        arcPath.transition("arc-path-update").duration(transitionTime).style("fill", function (d, i) {

            // get the ranking of this country in relation to the world, or region
            var ranking = d.data.ranking["2015"];
            ranking = isWorld ? ranking["world"] : ranking["region"];

            var color = colors(ranking / count);

            // darken the selected country
            if (d.data.name === selectedArea) {
                color = "#C7D66D";
            }

            return color;
        }).attr("d", function (d) {
            return d.data.name === selectedArea ? arcHover(d) : arc(d);
        });

        var textStyles = {
            "text-anchor": "middle",
            "stroke-width": 0,
            "display": function display(d) {
                return d.data.name === selectedArea ? "block" : "none";
            },
            "fill-opacity": "1" // make sure it's always reset after being the selected slice
        };

        // update outside label (country name)
        slice.select(".outside-label text").transition("outside-label-update").duration(transitionTime).attr("transform", function (d) {
            // find the angle of the center of the arc path
            var rotate = (d.startAngle - (d.startAngle - d.endAngle) / 2) * (180 / Math.PI); // radians to degrees

            // the origin is the center of the pie

            var _arc$centroid = arc.centroid(d);

            var _arc$centroid2 = _slicedToArray(_arc$centroid, 2);

            var x = _arc$centroid2[0];
            var y = _arc$centroid2[1];
            // center of arc path
            var h = Math.sqrt(x * x + y * y); // pythagorean theorem for hypotenuse
            x = x / h * outsideLabelRadius;
            y = y / h * outsideLabelRadius;

            return "translate(" + x + ", " + y + ") rotate(" + rotate + ")";
        }).style(textStyles).text(function (d) {
            return d.data.name;
        });

        // add inside label (country population ranking)
        slice.select(".inside-label").transition("inside-label-update").duration(transitionTime).attr("transform", function (d) {
            var rotate = (d.startAngle - (d.startAngle - d.endAngle) / 2) * (180 / Math.PI); // radians to degrees

            var _arc$centroid3 = arc.centroid(d);

            var _arc$centroid32 = _slicedToArray(_arc$centroid3, 2);

            var x = _arc$centroid32[0];
            var y = _arc$centroid32[1];

            var h = Math.sqrt(x * x + y * y); // pythagorean theorem for hypotenuse
            x = x / h * insideLabelRadius;
            y = y / h * insideLabelRadius;

            return "translate(" + x + ", " + y + ") rotate(" + rotate + ")";
        }).style(textStyles).text(function (d, i) {
            return i + 1;
        });

        /**
         * Slice events
         */

        // common function for touch and click
        var onSliceClick = function onSliceClick(d) {
            _dashboardDispatcherJs2["default"].setState({
                selectedArea: d.data.name
            });
        };

        // we need to handle touch because touch only devices will fire the mouseenter on the first touch (skipping click)
        // until the same touch happens again.
        // http://www.html5rocks.com/en/mobile/touchandmouse/
        slice.on("touchstart", function (d) {

            // prevent mouse events from occuring, see event order in article
            _d32["default"].event.preventDefault();

            onSliceClick(d);
        });

        // handle mouse events
        slice.on("mouseenter", function () {
            var slice = _d32["default"].select(this);

            // grow the path
            slice.select(".arc-path").transition("arc-path-hover").duration(100).attr("d", arcHover);

            // show the labels
            slice.select(".outside-label text").style({ "display": "block" });
            slice.select(".inside-label").style({ "display": "block" });

            // if there is a selected slice, dim the label if it intersects with this one
            if (!selectedSlice.empty()) {

                // if the user is hovering over the selected slice, un-dim it immediately
                if (selectedSlice.node() === slice.node()) {
                    selectedSlice.selectAll(".outside-label text, .inside-label").transition("text-opacity").duration(0).style({ "fill-opacity": "1" });
                }

                // otherwise, check if they are overlapping
                else {

                        // important to select the ".outside-label" and not ".outside-label text" (see HACK! above)
                        var selectedBBox = selectedSlice.select(".outside-label").node().getBBox();
                        var sliceBBox = slice.select(".outside-label").node().getBBox();

                        selectedSlice.selectAll(".outside-label text, .inside-label").transition("text-opacity").duration(150).style({ "fill-opacity": doBoxesIntersect(selectedBBox, sliceBBox) ? "0.1" : "1" });
                    }
            }
        }).on("mouseleave", function (d) {

            // don't revert if this is the selected country
            if (d.data.name === selectedArea) {
                return;
            }

            var slice = _d32["default"].select(this);

            // revert the path
            slice.select(".arc-path").transition("arc-path-hover").duration(100).attr("d", function (d) {
                return d.data.name === selectedArea ? arcHover(d) : arc(d);
            });

            // hide the labels
            slice.select(".outside-label text").style({ "display": function display(d) {
                    return d.data.name === selectedArea ? "block" : "none";
                } });
            slice.select(".inside-label").style({ "display": function display(d) {
                    return d.data.name === selectedArea ? "block" : "none";
                } });

            // always reset the opacity of the selected slice text
            selectedSlice.selectAll(".outside-label text, .inside-label").transition("text-opacity").duration(150).style({ "fill-opacity": "1" });
        }).on("click", function (d) {
            onSliceClick(d);
        });
    }

};

function doBoxesIntersect(a, b) {
    if (a.x + a.width <= b.x) return false; // a is left of b
    if (b.x + b.width <= a.x) return false; // a is right of b
    if (a.y + a.height <= b.y) return false; // a is above b
    if (b.y + b.height <= a.y) return false; // a is below b
    return true; // boxes overlap
}

exports["default"] = d3Arc;
module.exports = exports["default"];

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./dashboard-dispatcher.js":18}],17:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _d3 = (typeof window !== "undefined" ? window['d3'] : typeof global !== "undefined" ? global['d3'] : null);

var _d32 = _interopRequireDefault(_d3);

var margin = { top: 4, right: 10, bottom: 10, left: 10 };
var width = 60 - margin.left - margin.right,
    height = 200 - margin.top - margin.bottom,
    tickWidth = 16;

var d3Thermometer = {

    // axisLabel = ["normal", "none", "female", "male"] 
    // male is the same as none, female moves it over so it's "centered" when
    // the charts are next to each other

    create: function create(_ref) {
        var el = _ref.el;
        var data = _ref.data;
        var _ref$range = _ref.range;
        var range = _ref$range === undefined ? { min: 0, max: 100 } : _ref$range;
        var _ref$dataLabel = _ref.dataLabel;
        var dataLabel = _ref$dataLabel === undefined ? "left" : _ref$dataLabel;
        var _ref$axisLabel = _ref.axisLabel;
        var axisLabel = _ref$axisLabel === undefined ? "normal" : _ref$axisLabel;
        var units = _ref.units;
        var _ref$hover = _ref.hover;
        var hover = _ref$hover === undefined ? false : _ref$hover;

        // create and append the svg
        var svg = _d32["default"].select(el).append("svg").attr("width", width + margin.left + margin.right).attr("height", height + margin.top + margin.bottom).attr("class", "thermometer-svg").style({
            "overflow": "visible" // so the labels show
        }).append("g").attr("class", "thermometer-svg-g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");

        // draw axis
        this._drawAxis(el, range, axisLabel);

        // now update with the data
        this.update(arguments[0]);
    },

    // el: element to attach the chart to
    // counties: an array of country data
    update: function update(_ref2) {
        var _this = this;

        var el = _ref2.el;
        var data = _ref2.data;
        var _ref2$range = _ref2.range;
        var range = _ref2$range === undefined ? { min: 0, max: 100 } : _ref2$range;
        var _ref2$dataLabel = _ref2.dataLabel;
        var dataLabel = _ref2$dataLabel === undefined ? "left" : _ref2$dataLabel;
        var _ref2$axisLabel = _ref2.axisLabel;
        var axisLabel = _ref2$axisLabel === undefined ? "normal" : _ref2$axisLabel;
        var units = _ref2.units;
        var _ref2$hover = _ref2.hover;
        var hover = _ref2$hover === undefined ? false : _ref2$hover;

        // range.max = d3.max(data, (d) => d.value);

        var svg = _d32["default"].select(el).select(".thermometer-svg-g");

        var transitionTime = 500;

        var scale = _d32["default"].scale.linear().domain([range.min, range.max]).range([height, 0]);

        var points = {
            "world": {
                "stroke-width": 6,
                "stroke-length": 15
            },
            "region": {
                "stroke-width": 2,
                "stroke-length": 25
            },
            "country": {
                "radius": 7
            }
        };

        var colors = _d32["default"].scale.ordinal().domain(["world", "region", "country"]).range(["#82C09A", "#7F6EA5", "#F2AC00"]);

        // filter out undefined/null
        data = data.filter(function (d) {
            return d.value !== null && d.value !== undefined;
        }); // filter out undefined/null

        // only show the data label for country, or region, or world (in that order)
        var significantType = data.reduce(function (prev, cur) {
            if (cur.type === "country" || prev === "country") {
                return "country";
            }
            if (cur.type === "region" || prev === "region") {
                return "region";
            }
            if (cur.type === "world" || prev === "world") {
                return "world";
            }
        }, "");

        // create a "float" group to hold the float and the text
        // the second parameter defines a key for this element.  Because we're sorting the data, this is important
        var float = svg.selectAll(".float").data(data, function (d) {
            return d.type;
        });

        /**
         * Enter, when data points are added 
         */
        var newFloat = float.enter().append("g").attr("class", function (d) {
            return "float " + d.type;
        }).style({
            "stroke": "white",
            "stroke-width": "1px"
        });

        // world and region uses a line
        newFloat.filter(function (d) {
            return d.type !== "country";
        }).append("path").attr("d", function (d) {
            return _this._tick(scale(d.value), 0);
        }).style({
            "stroke": function stroke(d) {
                return colors(d.type);
            },
            "stroke-width": function strokeWidth(d) {
                return points[d.type]["stroke-width"];
            },
            "stroke-linecap": "round"
        });

        // country uses a cirlce
        newFloat.filter(function (d) {
            return d.type === "country";
        }).append("circle").attr("cx", width / 2).attr("r", 0).attr("opacity", 0.8).attr("fill", function (d) {
            return colors(d.type);
        });

        // the value label for the data point
        newFloat.append("text").style("fill-opacity", 0);

        /**
         * Exit, when data points are removed 
         */
        var exits = float.exit()
        // remove the class so selectAll(".floats") doesn't select this retreating element
        // this fixes a race condition related to transition timing
        .attr("class", "").transition("float-exit").duration(transitionTime);

        exits.remove();

        exits.select("circle").attr("r", 0).remove();
        exits.select("path").attr("d", function (d) {
            return _this._tick(scale(d.value), 0);
        }).remove();
        exits.select("text").style("fill-opacity", 0).remove();

        /**
         * Update, when data points are changed 
         */

        // world and region
        float.filter(function (d) {
            return d.type !== "country";
        }).select("path").transition("float-update").duration(transitionTime).attr("cy", function (d) {
            return scale(d.value);
        }).attr("d", function (d) {
            return _this._tick(scale(d.value), points[d.type]["stroke-length"]);
        });

        // country
        float.filter(function (d) {
            return d.type === "country";
        }).select("circle").transition("float-update").duration(transitionTime).attr("r", function (d) {
            return points[d.type].radius;
        }).attr("cy", function (d) {
            return scale(d.value);
        });

        // data label
        var labels = float.select("text");

        // common function to calculate the x position given "left" or "right".  we need to do this normally,
        // and also when the user hovers over the themermeter chart
        var calcX = function calcX(d) {
            var position = arguments.length <= 1 || arguments[1] === undefined ? "left" : arguments[1];

            // width/2 takes in account the length added by stroke-linecap: round;
            var offset = 0;
            if (points[d.type]["stroke-length"]) {
                offset = points[d.type]["stroke-length"] / 2 + points[d.type]["stroke-width"] / 2;
            }
            if (points[d.type]["radius"]) {
                offset = points[d.type]["radius"];
            }
            offset += 6; // padding

            return {
                "offset": position === "right" ? width / 2 + offset : width / 2 - offset,
                "textAnchor": position === "right" ? "start" : "end" // place the data label left or right
            };
        };

        // don't transition x.  Initially, put all labels on the dataLabel side
        labels.attr("x", function (d, i) {
            return calcX(d, dataLabel).offset;
        }).style("text-anchor", function (d, i) {
            return calcX(d, dataLabel).textAnchor;
        });

        // transition y and styles
        var labelTransition = labels.transition("label-update").duration(transitionTime).style({
            "fill": function fill(d) {
                return colors(d.type);
            },
            "stroke-width": 0,
            "dominant-baseline": "middle",
            "fill-opacity": function fillOpacity(d) {
                // only show the significantType (country, region, world)
                return d.type === significantType ? 1 : 0;
            }
        }).text(function (d) {
            return d.value + (units ? units : "");
        });

        // on hover, jump the non-significant labels to their position, then fade them in and "relax" them
        if (hover) {
            labels.attr("y", function (d) {
                return scale(d.value);
            });
            labelTransition.style("fill-opacity", 1);
            this.relaxLabels(labels);
        }

        // if this isn't on hover, transition the y
        else {
                labelTransition.attr("y", function (d) {
                    return scale(d.value);
                });
            }
    },

    // transition the labels away from each other so they don't overlapi9o
    relaxLabels: function relaxLabels(labels) {
        var _this2 = this;

        var alpha = 1;
        var spacing = 18;
        var again = false;

        labels.each(function (da, i) {
            var a = this;
            var d3a = _d32["default"].select(a);
            var ya = d3a.attr('y');

            labels.each(function (db, j) {
                var b = this;

                if (a === b) {
                    return;
                }

                var d3b = _d32["default"].select(b);
                var yb = d3b.attr("y");
                var deltaY = ya - yb;

                if (Math.abs(deltaY) > spacing) {
                    return;
                }

                again = true;
                var sign = deltaY > 0 ? 1 : -1;
                var adjust = sign * alpha;

                d3a.attr("y", +ya + adjust);
                d3b.attr("y", +yb - adjust);
            });
        });

        if (again) {
            setTimeout(function () {
                _this2.relaxLabels(labels);
            }, 16);
        }
    },

    _drawAxis: function _drawAxis(el, range, axisLabel) {

        var svg = _d32["default"].select(el).select(".thermometer-svg-g");

        var yAxis = svg.append("g").attr("class", "y axis");

        var yAxisStyle = {
            "stroke": "black",
            "stroke-width": "1px"
        };

        yAxis.append("path").style(yAxisStyle).attr("d", "M" + width / 2 + ",0 L" + width / 2 + "," + height);

        // top tick           
        yAxis.append("path").style(yAxisStyle).attr("d", this._tick(0, tickWidth));

        // bottom tick           
        yAxis.append("path").attr("d", this._tick(height, tickWidth)).style(yAxisStyle);

        // add axis labels
        if (range !== undefined && axisLabel !== "none" && axisLabel !== "male") {

            var style = {
                "dominant-baseline": "middle",
                "text-anchor": "start"
            };

            // label to the right of the axis
            var x = width / 2 + tickWidth / 2 + 3;

            var topY = 0;

            // move the label over if this is a "female"
            if (axisLabel === "female") {
                style["text-anchor"] = "middle";
                x = 0 - margin.left - parseInt(_d32["default"].select(el).style("padding-left")); // make sure it's centered
                // topY = "0.5em"; // make the top label be lower
            }

            yAxis.append("text").attr("x", x).attr("y", topY).style(style).text(range.max);

            yAxis.append("text").attr("x", x).attr("y", height).style(style).text(range.min);
        }
    },

    _tick: function _tick(y, tickWidth) {
        return "M" + (width / 2 - tickWidth / 2) + "," + y + " L" + (width / 2 + tickWidth / 2) + "," + y;
    }
};

exports["default"] = d3Thermometer;
module.exports = exports["default"];

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],18:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

require("./es6-polyfill.js");

var _react = (typeof window !== "undefined" ? window['React'] : typeof global !== "undefined" ? global['React'] : null);

var _react2 = _interopRequireDefault(_react);

var _dataloaderJs = require("./dataloader.js");

var _dataloaderJs2 = _interopRequireDefault(_dataloaderJs);

var _componentsDashboardJsx = require("./components/Dashboard.jsx");

var _componentsDashboardJsx2 = _interopRequireDefault(_componentsDashboardJsx);

var dispatcher = {

    // initial app state
    state: {

        // user supplied
        year: 2015,
        selectedArea: "", // World, a region, or a country

        // doesn't change, from json
        rawData: null,

        // calucalted (see addCalculatedStateValues)
        selectedAreaData: {},
        countries: [],
        region: "", // World or a region.  determines what to show in the arc
        genderFocusData: {}
    },

    // initialize the data and load the initial region
    start: function start() {
        var _this = this;

        // load the json data
        _dataloaderJs2["default"].loadData().done(function (jsonData, textStatus, jqXHR) {

            // add the raw data to the state so it's accessible
            _this.state.rawData = jsonData;

            // default to "World"
            _this.setState({
                selectedArea: _this.state.rawData.name
            });
        });
    },

    // set the state and rerender
    setState: function setState(newState) {

        newState = this.willReceiveNewState(newState);

        // merge the new state with the current state
        var mergedState = Object.assign({}, this.state, newState);

        // don't update if the new merged state is the same as the old state
        if (JSON.stringify(this.state) === JSON.stringify(mergedState)) {
            return;
        }

        // otherwise, update this.state
        this.state = mergedState;

        // update the dataLayer for google tag manager
        if (this.state.selectedArea) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                "event": "selectionchange",
                "selectedArea": this.state.selectedArea
            });
        }

        this.render();
    },

    // do any processing on the new state in relation to the old state
    willReceiveNewState: function willReceiveNewState(newState) {

        // if the user clicked a region, and a country in that region is the selectedArea,
        // keep that country selected.
        if (this.state.region === this.state.rawData.name // "World"
         && _dataloaderJs2["default"].isRegion(newState.selectedArea) && _dataloaderJs2["default"].isCountryInRegion(newState.selectedArea, this.state.selectedArea)) {
            newState.selectedArea = this.state.selectedArea;
            newState.region = newState.selectedArea;
        }

        // if the selectedArea was a country, and the user clicked the world, keep that country selected
        // and show the world region in the arc
        if (newState.selectedArea === this.state.rawData.name // "World"
         && _dataloaderJs2["default"].isCountry(this.state.selectedArea) && this.state.region !== this.state.rawData.name // "World"
        ) {
                newState.selectedArea = this.state.selectedArea;
                newState.region = this.state.rawData.name; // "World"
            }

        return newState;
    },

    // after we determine this state, calculate any addition items
    addCalculatedStateValues: function addCalculatedStateValues() {

        // calculate which region is selected
        this.state.region = _dataloaderJs2["default"].getRegion(this.state.selectedArea, this.state.region);

        // get the selected area data
        this.state.selectedAreaData = _dataloaderJs2["default"].getAreaData(this.state.selectedArea);

        // reload data with this region/year, and add it to the state
        this.state.countries = _dataloaderJs2["default"].getRegionCountries(this.state.region, this.state.year);

        // data for the gender focus charts
        this.state.genderFocusData = _dataloaderJs2["default"].getGenderFocusData(this.state.selectedArea);

        // if the shown region is "World"
        this.state.isWorld = this.state.region === this.state.rawData.name; // "World"
    },

    render: function render() {

        this.addCalculatedStateValues();

        // console.log("dispatcher state: ", this.state);

        // re-render the Dashboard with this state
        _react2["default"].render(_react2["default"].createElement(_componentsDashboardJsx2["default"], { appState: this.state }), document.querySelector(".dashboard"));
    }

};

exports["default"] = dispatcher;
module.exports = exports["default"];

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./components/Dashboard.jsx":3,"./dataloader.js":19,"./es6-polyfill.js":20}],19:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

require("./es6-polyfill.js");

var _jquery = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var _jquery2 = _interopRequireDefault(_jquery);

var dataLoader = {

    loadData: function loadData() {
        var _this = this;

        return _jquery2["default"].ajax({
            url: "data/population.json",
            cache: true
        }).done(function (jsonData, textStatus, jqXHR) {
            _this.data = jsonData;
            _this.addRankingData();

            // sort regions a-z
            _this.data.children.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
        }).fail(function (jqXHR, textStatus, errorThrown) {
            console.error("Error loading json", jqXHR);
        });
    },

    // add ranking data to our structure
    addRankingData: function addRankingData() {
        var _this2 = this;

        var worldCounties2015 = this.getWorldData(2015);
        var worldCounties2050 = this.getWorldData(2050);

        // clone and put the regions in order
        var regions2015 = this.data.children.slice(0).sort(function (a, b) {
            var key = "2015";
            return b.population[key] - a.population[key];
        });

        var regions2050 = this.data.children.slice(0).sort(function (a, b) {
            var key = "2015";
            return b.population[key] - a.population[key];
        });

        // add empty ranking to world so it doesn't complain
        Object.assign(this.data, { ranking: {} });

        // for each region, update it's own rankings, and it's countries rankings
        this.data.children.forEach(function (region) {

            Object.assign(region, {
                "ranking": {
                    "2015": {
                        "world": 1 + regions2015.findIndex(function (r) {
                            return region.name === r.name;
                        })
                    },
                    "2050": {
                        "world": 1 + regions2050.findIndex(function (r) {
                            return region.name === r.name;
                        })
                    }
                }
            });

            // update each country rankings
            var thisRegion2015 = _this2.getRegionCountries(region.name, "2015");
            var thisRegion2050 = _this2.getRegionCountries(region.name, "2050");

            region.children.forEach(function (country, i) {
                Object.assign(country, {
                    "ranking": {
                        "2015": {
                            "world": 1 + worldCounties2015.findIndex(function (c) {
                                return country.name === c.name;
                            }),
                            "region": 1 + thisRegion2015.findIndex(function (c) {
                                return country.name === c.name;
                            })
                        },
                        "2050": {
                            "world": 1 + worldCounties2050.findIndex(function (c) {
                                return country.name === c.name;
                            }),
                            "region": 1 + thisRegion2050.findIndex(function (c) {
                                return country.name === c.name;
                            })
                        }
                    }
                });
            });
        });
    },

    // given "World", a region, or a country, return the region that it belongs to.
    // if we're already in the "World" view, only select a region if it's explicitly selected.
    // ie. stay in the "World" view if a country is selected.
    getRegion: function getRegion(selectedArea, currentRegion) {
        var _this3 = this;

        // if the current region is world, keep it as world
        if (selectedArea === this.data.name) {
            return this.data.name;
        }

        return this.data.children.reduce(function (prev, region, i) {

            // if the selectedArea is a region
            if (region.name === selectedArea) {
                return region.name;
            }

            // if we're in the world view, and a country is selected, stay in world view
            if (currentRegion !== _this3.data.name) {

                // if the selectedArea is a country
                var regionContains = region.children.some(function (country) {
                    if (country.name === selectedArea) {
                        return true;
                    }
                });

                if (regionContains) {
                    return region.name;
                }
            }

            return prev;
        }, this.data.name); // default to "World"
    },

    // returns true/false whether or not the selectedArea is a region (as opposed to country)
    isRegion: function isRegion(selectedArea) {

        if (!this.data) {
            throw new Error("set data first!");
        }

        var region = this.data.children.find(function (el, i, array) {
            return el.name === selectedArea;
        });

        return region !== undefined;
    },

    // return true/false whether the selectedArea is a country
    isCountry: function isCountry(selectedArea) {
        if (!this.data) {
            throw new Error("set data first!");
        }

        var area = this.getAreaData(selectedArea);

        return area && !area.children;
    },

    // given a region and a country, return true if the country is in that region
    isCountryInRegion: function isCountryInRegion(regionName, countryName) {

        if (!this.data) {
            throw new Error("set data first!");
        }

        var region = this.data.children.find(function (el, i, array) {
            return el.name === regionName;
        });

        if (!region) {
            return false;
        }

        var country = region.children.find(function (el, i, array) {
            return el.name === countryName;
        });

        return country !== undefined;
    },

    // returns the country/region/world object
    getAreaData: function getAreaData(selectedArea) {

        if (!this.data) {
            throw new Error("set data first!");
        }

        // World
        if (selectedArea === this.data.name) {
            return this.data;
        }

        for (var i in this.data.children) {
            var region = this.data.children[i];

            if (region.name === selectedArea) {
                return region;
            } else if (region.children) {
                for (var j in region.children) {
                    var country = region.children[j];

                    if (country.name === selectedArea) {
                        return country;
                    }
                }
            }
        }

        return undefined;
    },

    // shared function for getWorldData and getRegionCountries
    _countryMap: function _countryMap(country) {
        return {
            name: country.name,
            population: country.population,
            ranking: country.ranking
        };
    },

    // recursivly go through the world/region children to extract the country population data
    getWorldData: function getWorldData(year) {
        var _this4 = this;

        if (!this.data) {
            throw new Error("set data first!");
        }

        return this.data.children.flatMap(function (region) {
            return region.children.map(_this4._countryMap);
        }).sort(function (a, b) {
            var key = String(year);
            return b.population[key] - a.population[key];
        });
    },

    // returns the list of countries and thier population in a given region ordered by the population
    // in the given year
    getRegionCountries: function getRegionCountries(regionName, year) {

        if (!this.data) {
            throw new Error("set data first!");
        }

        // if we need to load the world data
        if (regionName === this.data.name) {
            return this.getWorldData(year);
        }

        var region = this.data.children.find(function (el, i, array) {
            return el.name === regionName;
        });

        if (!region || !region.children) {
            throw "Can't find region \"" + regionName + "\"!";
        }

        // extract the data for this region
        return region.children.map(this._countryMap).sort(function (a, b) {
            var key = String(year);
            return b.population[key] - a.population[key];
        });
    },

    getRegionForCountry: function getRegionForCountry(countryName) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {

            for (var _iterator = this.data.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var region = _step.value;

                if (this.isCountryInRegion(region.name, countryName)) {
                    return region;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator["return"]) {
                    _iterator["return"]();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        throw new Error("Can't find region for " + countryName);
    },

    // returns the parents of the selected area
    // eg. if a region is selected, country will be empty
    // {"world": {}, "region": {}, "country": {}};
    getSelectedAreas: function getSelectedAreas(selectedArea) {

        var selected = this.getAreaData(selectedArea);

        if (!selected) {
            throw new Error(selectedArea + " not found!");
        }

        // object to hold the data for each area
        var areas = { "world": {}, "region": {}, "country": {} };

        // the selected area is "World"
        if (selected.name === this.data.name) {
            areas.world = selected;
        }

        // the selected area is region
        else if (this.isRegion(selected.name)) {
                areas.world = this.data;
                areas.region = selected;
            }

            // the selected area is a country
            // else if (this.isCountry(area.name)) { // slower, not needed?
            else {
                    areas.world = this.data;
                    areas.region = this.getRegionForCountry(selected.name);
                    areas.country = selected;
                }

        return areas;
    },

    // return the relevant data for the gender focus charts
    getGenderFocusData: function getGenderFocusData(selectedArea) {

        if (!this.data) {
            throw new Error("set data first!");
        }

        var areas = this.getSelectedAreas(selectedArea);

        var panels = [{
            "title": "Fertility",
            "key": "fertility",
            "panels": [{
                "key": "rate",
                "subTitle": "Total Fertility Rate",
                "range": { "min": 0, "max": 8 },
                "info": "The average number of children a woman would have assuming that current age-specific birth rates remain constant throughout her childbearing years (usually considered to be ages 15 to 49).",
                "hasSignificantData": null
            }, {
                "key": "contraception",
                "subTitle": "% Use of Modern Contraception",
                "units": "%",
                "range": { "min": 0, "max": 100 },
                "info": "The percentage of currently married or “in union” women of reproductive age who are currently using “modern” methods of contraception. “Modern” methods include clinic and supply methods such as the pill, IUD, condom, and sterilization.",
                "hasSignificantData": null
            }],
            "panelType": "double"
        }, {
            "title": "Education",
            "key": "education",
            "subTitle": "% Enrolled in Secondary School",
            "units": "%",
            "panelType": "male-female",
            "range": { "min": 0, "max": 140 },
            "info": "The ratio of the number of students enrolled in secondary school to the population in the age group that officially corresponds to secondary-level education (such as ages 12 to 17) for the country. This is the gross enrollment ratio (GER), which counts enrolled students regardless of age. The GER can exceed 100 percent due to the inclusion of over-aged and/or under-aged students because of early or late school entrance and grade repetition.  ",
            "hasSignificantData": null
        }, {
            "title": "Employment",
            "key": "employment",
            "subTitle": "% Nonagricultural Wage Earners Who Are Women ",
            "units": "%",
            "panelType": "single",
            "range": { "min": 0, "max": 60 },
            "info": "Women’s share of paid employment in nonagricultural sectors (such as industry or services) as a percentage of total nonagricultural wage-earning employees. ",
            "hasSignificantData": null
        }, {
            "title": "Government",
            "key": "government",
            "subTitle": "% Parliament Members Who Are Women",
            "units": "%",
            "panelType": "single",
            "range": { "min": 0, "max": 60 },
            "info": "The percentage of seats in a country’s single chamber,  combined higher and lower chambers of the national parliament, or other national legislature held by women.",
            "hasSignificantData": null
        }, {
            "title": "Health",
            "key": "health",
            "subTitle": "Life Expectancy at Birth (Years)",
            "panelType": "male-female",
            "range": { "min": 40, "max": 100 },
            "info": "The average number of years a newborn male or female infant can expect to live under current mortality levels. ",
            "hasSignificantData": null
        }];

        // only show the data for country, or region, or world (in that order)
        var significantAreaType = (function (a) {
            if (Object.keys(a.country).length) {
                return "country";
            }
            if (Object.keys(a.region).length) {
                return "region";
            }
            if (Object.keys(a.world).length) {
                return "world";
            }
        })(areas);

        // add the data to the panels in the appropriate format for the panel type
        panels = panels.map(function (p) {

            switch (p.panelType) {
                // normal charts
                case "single":
                    p.data = ["world", "region", "country"].map(function (wrc) {
                        return {
                            "type": wrc,
                            "value": areas[wrc][p.key]
                        };
                    }).filter(function (area) {
                        return area.value !== null && area.value !== undefined;
                    }); // filter out undefined/null

                    // whether or not it contains data for the selectedArea
                    var significantData = p.data.find(function (p) {
                        return p.type === significantAreaType;
                    });
                    p.hasSignificantData = typeof significantData !== "undefined";

                    break;

                // double charts
                case "double":

                    p.panels.map(function (sp) {
                        sp.data = ["world", "region", "country"].map(function (wrc) {
                            return {
                                "type": wrc,
                                "value": areas[wrc][p.key] ? areas[wrc][p.key][sp.key] : null
                            };
                        }).filter(function (area) {
                            return area.value !== null && area.value !== undefined;
                        }); // filter out undefined/null;

                        // whether or not it contains data for the selectedArea
                        var significantData = sp.data.find(function (p) {
                            return p.type === significantAreaType;
                        });
                        sp.hasSignificantData = typeof significantData !== "undefined";
                    });

                    break;

                // male-female charts
                case "male-female":

                    p.data = { male: [], female: [] };

                    ["male", "female"].forEach(function (mf) {

                        p.data[mf] = ["world", "region", "country"].map(function (wrc) {
                            return {
                                "type": wrc,
                                "value": areas[wrc][p.key] ? areas[wrc][p.key][mf] : null
                            };
                        }).filter(function (area) {
                            return area.value !== null && area.value !== undefined;
                        }); // filter out undefined/null
                    });

                    // whether or not it contains data for the selectedArea
                    p.hasSignificantData = ["male", "female"].some(function (mf) {
                        var significantData = p.data[mf].find(function (p) {
                            return p.type === significantAreaType;
                        });
                        return typeof significantData !== "undefined";
                    });

                    break;

            }

            return p;
        });

        return {
            areas: areas,
            panels: panels
        };
    }
};

// {
//     "title": "government",
//     "subTitle": "% parliament members who are women",
//     "data": [
//         {
//             "type": "world",
//             "value": 123
//         },
//         {
//             "type": "region",
//             "value": 456
//         },
//     ]
// },
// {
//     "title": "health",
//     "subTitle": "Life expectancy at birth (years)",
//     "data": {
//         "male": [
//             { "type": "world", "value": 123},
//             { "type": "region", "value": 456},
//         ],
//         "female": [
//             { "type": "world", "value": 345},
//             { "type": "region", "value": 234},
//         ]
//     }
// }

/**
 * polyfills
 */

// define flatMap
// map over elements (and return an array), then flatten the results.
(function () {
    if (Array.prototype.flatMap) {
        return;
    }

    var flatMap = function flatMap(fn) {
        var array = Object(this);

        var results = [];

        array.forEach(function (obj) {
            results.push(fn(obj));
        });
        // console.log(results);
        return results.flatten();
    };

    if (Object.defineProperty) {
        try {
            Object.defineProperty(Array.prototype, "flatMap", {
                value: flatMap,
                configurable: true,
                enumerable: false,
                writable: true
            });
        } catch (e) {}
    }

    if (!Array.prototype.flatMap) {
        Array.prototype.flatMap = flatMap;
    }
})();

// define flatten, given an array of arrays, flatten it
// eg [[1, 2], [3, 4]]  => [1, 2, 3, 4]
(function () {
    if (Array.prototype.flatten) {
        return;
    }

    var flatten = function flatten() {
        var array = Object(this);

        return array.reduce(function (a, b) {
            return a.concat(b);
        });
    };

    if (Object.defineProperty) {
        try {
            Object.defineProperty(Array.prototype, "flatten", {
                value: flatten,
                configurable: true,
                enumerable: false,
                writable: true
            });
        } catch (e) {}
    }

    if (!Array.prototype.flatten) {
        Array.prototype.flatten = flatten;
    }
})();

exports["default"] = dataLoader;
module.exports = exports["default"];

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./es6-polyfill.js":20}],20:[function(require,module,exports){
// Object.assign
'use strict';

(function () {

    if (Object.assign) {
        return;
    }

    Object.defineProperty(Object, 'assign', {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function value(target) {
            'use strict';
            if (target === undefined || target === null) {
                throw new TypeError('Cannot convert first argument to object');
            }

            var to = Object(target);
            for (var i = 1; i < arguments.length; i++) {
                var nextSource = arguments[i];
                if (nextSource === undefined || nextSource === null) {
                    continue;
                }
                nextSource = Object(nextSource);

                var keysArray = Object.keys(Object(nextSource));
                for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
                    var nextKey = keysArray[nextIndex];
                    var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                    if (desc !== undefined && desc.enumerable) {
                        to[nextKey] = nextSource[nextKey];
                    }
                }
            }
            return to;
        }
    });
})();

// Array.find
(function () {
    if (Array.prototype.find) {
        return;
    }

    Object.defineProperty(Array.prototype, "find", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function value(predicate) {
            if (this === null) {
                throw new TypeError("Array.prototype.find called on null or undefined");
            }
            if (typeof predicate !== "function") {
                throw new TypeError("predicate must be a function");
            }
            var list = Object(this);
            var length = list.length >>> 0;
            var thisArg = arguments[1];
            var value;

            for (var i = 0; i < length; i++) {
                value = list[i];
                if (predicate.call(thisArg, value, i, list)) {
                    return value;
                }
            }
            return undefined;
        }
    });
})();

// Array.findIndex
(function () {
    if (Array.prototype.findIndex) {
        return;
    }

    Object.defineProperty(Array.prototype, "findIndex", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function value(predicate) {
            if (this == null) {
                throw new TypeError('Array.prototype.findIndex called on null or undefined');
            }
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }
            var list = Object(this);
            var length = list.length >>> 0;
            var thisArg = arguments[1];
            var value;

            for (var i = 0; i < length; i++) {
                value = list[i];
                if (predicate.call(thisArg, value, i, list)) {
                    return i;
                }
            }
            return -1;
        }
    });
})();

},{}],21:[function(require,module,exports){
"use strict";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _dashboardDispatcherJs = require("./dashboard-dispatcher.js");

var _dashboardDispatcherJs2 = _interopRequireDefault(_dashboardDispatcherJs);

_dashboardDispatcherJs2["default"].start();

},{"./dashboard-dispatcher.js":18}]},{},[21]);
